/**
 * Abas disponíveis (§5.4.1). A regra mora em `model/scene.ts` (uma versão só, DE-B02); a UI a lê pelo computed
 * `offices` de `state/derived.ts`.
 */
import { availableOffices } from '../model/scene';
import type { RouteOffice } from '../model/types';
import type { RouteContext } from './types';

export { availableOffices };

/**
 * Cargo da n-ésima aba (1–4), para os atalhos `1`–`4` (§5.4.5, M21). null se a aba não existe ou se há menos de 2 abas
 * (com menos de 2, `OfficeTabs` não é renderizado e os atalhos não fazem nada).
 */
export function officeAt(
  ctx: Pick<RouteContext, 'flags' | 'candidates' | 'governorUfs'>,
  n: number,
): RouteOffice | null {
  const list = availableOffices(ctx);
  if (list.length < 2) return null;
  return list[n - 1] ?? null;
}

/**
 * A tela de comentários existe (ORD-F-026): no replay, com a camada de comentários (`replay_commentary`); no ao vivo,
 * com `commentary_timeline` e os comentários ao vivo (`commentary`) ligados (PR 6). Fora disso, `tela=` é ignorado.
 */
export function screenAvailable(ctx: Pick<RouteContext, 'flags'>): boolean {
  return ctx.flags.replay_commentary || (ctx.flags.commentary_timeline && ctx.flags.commentary);
}

/** O cargo está disponível no contexto (passo 4 de §5.2.2). */
export function isOfficeAvailable(
  office: RouteOffice,
  ctx: Pick<RouteContext, 'flags' | 'candidates' | 'governorUfs'>,
): boolean {
  return availableOffices(ctx).includes(office);
}
